import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(null, {

    [actions.VIEW_STOMPUNKT]: (state, action) => action.id,
    [actions.CLEAR_STOMPUNKT]: (state, action) => null

})


// WEBPACK FOOTER //
// ./src/reducers/currentStompunkt.js